import axios from "./axios";

export async function deleteOffer(payload) {
  return axios
    .delete(`/offers/` + payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || { error: "Failed to delete offer" };
    });
}

export async function createOffer(payload) {
  return axios
    .post(`/offers/`, { offer: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // Return error object with proper structure for Redux Toolkit to handle
      if (error.response) {
        // Server responded with error status
        return Promise.reject({
          response: {
            status: error.response.status,
            data: error.response.data,
          },
          message: error.message,
        });
      } else if (error.request) {
        // Request was made but no response received
        return Promise.reject({
          response: {
            status: 0,
            data: { error: "No response from server" },
          },
          message: "Network error",
        });
      } else {
        // Something else happened
        return Promise.reject({
          response: {
            status: 500,
            data: { error: error.message },
          },
          message: error.message,
        });
      }
    });
}

export async function updateOffer(payload) {
  return axios
    .put(`/offers/` + payload.id, { offer: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // Return error object with proper structure for Redux Toolkit to handle
      if (error.response) {
        // Server responded with error status
        return Promise.reject({
          response: {
            status: error.response.status,
            data: error.response.data,
          },
          message: error.message,
        });
      } else if (error.request) {
        // Request was made but no response received
        return Promise.reject({
          response: {
            status: 0,
            data: { error: "No response from server" },
          },
          message: "Network error",
        });
      } else {
        // Something else happened
        return Promise.reject({
          response: {
            status: 500,
            data: { error: error.message },
          },
          message: error.message,
        });
      }
    });
}

export async function fetchOffer(payload) {
  // payload is only ID
  return axios
    .get(`/offers/` + payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || { error: "Failed to fetch offer" };
    });
}

export async function fetchOffers(controller) {
  return axios({ method: "get", url: "/offers/list", params: controller })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || { error: "Failed to fetch offers" };
    });
}

export async function sendOffer(payload) {
  return axios
    .post(`/offers/${payload.id}/send_offer`, { offer: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || { error: "Failed to send offer" };
    });
}

export async function getPdfOffer(payload) {
  return axios
    .get(`/offers/${payload.id}/pdf_offer`, { params: payload.params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || { error: "Failed to get PDF offer" };
    });
}

export async function checkSendOfferStatus(jobId) {
  return axios
    .get(`/offers/send_offer_status/${jobId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || { error: "Failed to check send status" };
    });
}

